import { OnlineChatConfigContainer } from '@yotpo-ui/online-chat';
import { ConfigService } from '@yotpo-ui/core';

export class OnlineChatConfig implements OnlineChatConfigContainer {
  serializedConfig = this.configService.getConfig().OnlineChatConfig;

  constructor(private configService: ConfigService) {}
}
